function coerceEmployeeLoggedInValue(value: unknown): boolean | undefined {
  if (value === null || value === undefined) return undefined;
  if (typeof value === "boolean") return value;
  if (typeof value === "number" && Number.isFinite(value)) return value !== 0;
  if (typeof value === "string") {
    const s = value.trim().toLowerCase();
    if (s === "true" || s === "1" || s === "yes") return true;
    if (s === "false" || s === "0" || s === "no" || s === "") return false;
  }
  return undefined;
}

const EMPLOYEE_LOGGED_IN_KEYS = [
  "employee_loggedin",
  "employeeLoggedIn",
  "employee_logged_in",
] as const;

export function readEmployeeLoggedInFromTeamRow(row: Record<string, unknown>): boolean | undefined {
  for (const key of EMPLOYEE_LOGGED_IN_KEYS) {
    if (!Object.prototype.hasOwnProperty.call(row, key)) continue;
    const coerced = coerceEmployeeLoggedInValue(row[key]);
    if (coerced !== undefined) return coerced;
  }
  return undefined;
}

export function getEmployeeLoggedInBoolean(row: Record<string, unknown>): boolean {
  return readEmployeeLoggedInFromTeamRow(row) ?? false;
}
